import React, { useEffect, useState } from 'react'
import { Autocomplete, Box, Chip, TextField } from '@mui/material'

import { dsColorNew } from '@palette'

/**
 * Tier picker — multi-select that expands client-side into a flat list
 * of provider ids.
 *
 * Each tier carries its own `provider_ids` (resolved by the backend
 * from MASTER_TIERS.providers), so when the user picks one or more
 * tiers we hand back the union of those provider ids. The parent
 * usually combines this with the explicit Provider picker.
 *
 *   <TierSlicer value={[201]} onChange={(tierIds, providerIds) => ...}/>
 */
export default function TierSlicer({ value = [], onChange, label = 'Tiers' }) {
	const [options, setOptions] = useState([])
	useEffect(() => {
		fetch('/api/my-business/catalog/tiers', { credentials: 'include' })
			.then(r => r.ok ? r.json() : [])
			.then(setOptions)
			.catch(() => setOptions([]))
	}, [])

	const selected = options.filter(o => value.includes(o.id))

	const emit = (items) => {
		const tierIds  = items.map(x => x.id)
		const provSet  = new Set()
		items.forEach(x => (x.provider_ids || []).forEach(p => provSet.add(p)))
		onChange(tierIds, [...provSet])
	}

	return (
		<Autocomplete multiple size="small" sx={{ minWidth: 220 }}
		              options={options}
		              value={selected}
		              getOptionLabel={(o) => o.name}
		              isOptionEqualToValue={(a, b) => a.id === b.id}
		              onChange={(_, v) => emit(v)}
		              renderOption={(props, o) => (
			              <Box component="li" {...props} key={o.id}>
				              <Box display="flex" alignItems="center" gap={1} width="100%">
					              <Box flex={1}>{o.name}</Box>
					              <Box sx={{ color: dsColorNew.textMuted, fontSize: 12 }}>
						              {o.provider_ids?.length || 0} providers
					              </Box>
				              </Box>
			              </Box>
		              )}
		              renderInput={(params) => (
			              <TextField {...params} InputLabelProps={{ ...params.InputLabelProps, shrink: true }} label={label}
			                         placeholder={selected.length ? '' : 'All'}/>
		              )}/>
	)
}
